<template>
  <v-data-table
    v-if="companyApps"
    :headers="headers"
    :items="companyApps"
    :items-per-page="50"
    item-key="applicationId"
    class="elevation-1"
    @click:row="clickedRow"
  >
    <template
      v-slot:[`item.action`]="{ item }"
      v-if="allowed(null, Roles.AdminOrCompanyAdmin)"
    >
      <v-icon dark color="error" @click="deleteItem(item)">delete</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CompanyApps",
  data() {
    return {
      expanded: [],
      headers: [
        { text: this.$t("application.fields.id"), value: "applicationId" },
        { text: this.$t("application.fields.name"), value: "name" },
        { text: this.$t("application.fields.createdAt"), value: "createdAt" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState("users", ["currentUser", "userCompany", "hasCompany"]),
    ...mapState("companies", ["status", "companyApps"]),
    ...mapState("applications", { applicationStatus: "status" })
  },
  methods: {
    ...mapActions("companies", ["getCompanyApplications"]),
    ...mapActions("applications", ["deleteApplication"]),

    clickedRow(item) {
      if (this.allowed(null, this.Roles.AdminOrCompanyAdmin))
        this.$router.push(`/application/${item.applicationId}`);
    },

    deleteItem(item) {
      this.deleteApplication({
        applicationId: item.applicationId
      });
    }
  },

  created() {
    this.getCompanyApplications();
  }
};
</script>

<style></style>
